import React from 'react'
import styled from 'styled-components'
import { t } from '@/i18n'

interface TypeTagProps {
  type: 'OriginTypeCustom' | string
}

const TypeTag: React.FC<TypeTagProps> = ({ type }) => {
  const isCustom = type === 'OriginTypeCustom'

  return (
    <StyledTag bgColor={isCustom ? '#F77B83' : '#1F8FA7'} color="#fff">
      {isCustom ? t('手动添加') : t('系统内置')}
    </StyledTag>
  )
}

const StyledTag = styled.span<{ bgColor: string; color: string }>`
  display: inline-block;
  height: 18px;
  padding: 0 4px;
  background: ${props => props.bgColor};
  border-radius: 4px;
  line-height: 18px;
  color: ${props => props.color};
  font-size: 12px;
  margin-right: 4px;
`

export default TypeTag
